import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Image } from '@bottomless/common/components';
import { ScaleFaq } from './ScaleFaq';
import { ScaleLoading } from './ScaleLoading';

export const ConnectScale = ({ isConnected, onConnectedFinished, flow }) => {
  const [isOpen, setOpen] = useState(false);

  const onClick = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();

    setOpen(true);
  }, []);

  return (
    <>
      <Box secondary className="mb-4">
        <h2 className="text-center mb-4">
          {flow === 'tare' ? "Connect to your scale's WiFi" : 'Connect your scale to Wi-Fi'}
        </h2>
        <div className="text-center mb-3">
          On your smartphone or computer, go to Wi-Fi settings, then select the network named{' '}
          <strong>&quot;Bottomless_Scale&quot;</strong>.
        </div>
        <div className="text-center">
          <Image src="/connect-scale/wifi-list.jpg" alt="Wi-Fi list" width="250" useSrcset className="mb-4" />
        </div>
        <div className="text-center mb-5">
          Wait for a pop-up on your device and follow the displayed instructions to complete the{' '}
          {flow === 'tare' ? 'process' : 'connection'}.
        </div>
        <ScaleLoading className="mb-5" isConnected={isConnected} onConnectedFinished={onConnectedFinished} />
        <div className="text-center mt-3">
          <a href="#" onClick={onClick}>
            Need help? See FAQ
          </a>
        </div>
      </Box>
      {isOpen && <ScaleFaq />}
    </>
  );
};

ConnectScale.propTypes = {
  isConnected: PropTypes.bool,
  onConnectedFinished: PropTypes.func.isRequired,
  flow: PropTypes.string,
};
